import { CheckboxFrame, CheckboxIndicatorFrame } from "./Checkbox.mjs";
import { createCheckbox } from "./createCheckbox.mjs";
export * from "./createCheckbox.mjs";
export * from "./Checkbox.mjs";
export * from "./CheckboxStyledContext.mjs";
const Checkbox = createCheckbox({
  Frame: CheckboxFrame,
  Indicator: CheckboxIndicatorFrame
});
export { Checkbox };
//# sourceMappingURL=index.mjs.map
